{
  "WALLBOARD": {
    "LOADING": "Učitavanje redova čekanja...",
    "NO_QUEUES": "Nije pronađen nijedan red čekanja.",
    "NO_AGENTS": "Nema agenata na mreži u ovom redu.",
    "UNKNOWN_CALLER": "Nepoznat pozivalac",
    "STATUS": "Status",
    "TIME": "Vreme",
    "AGENT": "Agent",
    "EXTENSION": "Lokal",
    "READY": "Spremni agenti",
    "ON_CALL": "Agenti na pozivu",
    "PAUSED": "Agenti na pauzi",
    "WAITING": "Pozivi na čekanju",
    "MISSED_CALLS": "Propušteni pozivi",
    "HANDLED_CALLS": "Obrađeni dolazni pozivi",
    "OUTBOUND_CALLS": "Obrađeni izlazni pozivi",
    "AVAILABILITY": "Dostupnost",
    "AVAILABILITY_TOOLTIP": "Procenat dolaznih poziva na koje su agenti odgovorili (pozivi koji su preuzeti)",
    "AGENTS_COUNT": "({onCall} na pozivu / {total} ukupno)",
    "NO_AVAILABLE": "(niko nije na mreži)",
    "WAITING_CALLERS_COUNT": "{count} čeka",
    "CALLER": "Pozivalac",
    "NUMBER": "Broj",
    "WAIT_TIME": "Vreme čekanja",
    "ACTION": "Radnja",
    "PICKUP_CALL": "Preuzmi",
    "PICKUP_SUCCESS": "Preuzimanje poziva je uspešno zatraženo.",
    "PICKUP_ERROR": "Nije uspelo preuzimanje poziva. Pokušajte ponovo.",
    "PICKUP_DISABLED_TOOLTIP": "Ne možete preuzeti poziv dok ste na pozivu ili van mreže.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nema pristupa"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nema pristupa"
    }
  }
}
